import { createFileRoute } from "@tanstack/react-router";
import SpvFeeDiscount from "@/components/SpvFeeDiscount";

function RouteComponent() {
  return <SpvFeeDiscount />;
}

export const Route = createFileRoute("/_authenticated/spv-fee-discounts/")({
  component: RouteComponent,
  staticData: { page: "finance" },
});
